import * as React from "react";
import type { SVGProps } from "react";
import PropTypes from 'prop-types';
/* istanbul ignore file */
interface Props extends SVGProps<SVGSVGElement> {
  srText?: string;
  size?: 'sm' | 'md' | 'lg' | 'scale-8' | 'scale-10' | number;
  alt?: string;
}
function IconListDefault({
  srText,
  size = 'md',
  className = '',
  ...props
}: Props) {
  const newClassName = `mc-icon mc-icon--${size} ${className}`;
  return <>{!!srText && <span className='mc-sr-only'>{srText}</span>}<svg xmlns="http://www.w3.org/2000/svg" width={24} height={25} fill="none" viewBox="0 0 24 24" aria-hidden="true" role="img" className={newClassName} {...props}><path fill="currentColor" fillRule="evenodd" d="M4.5 3.75a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5M2 5a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0M4.5 11.25a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5M2 12.5a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0M4.5 18.75a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5M2 20a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0M8.25 5c0-.345.28-.625.625-.625h12.5a.625.625 0 1 1 0 1.25h-12.5A.625.625 0 0 1 8.25 5M8.25 12.5c0-.345.28-.625.625-.625h12.5a.625.625 0 1 1 0 1.25h-12.5a.625.625 0 0 1-.625-.625M8.25 20c0-.345.28-.625.625-.625h12.5a.625.625 0 1 1 0 1.25h-12.5A.625.625 0 0 1 8.25 20" clipRule="evenodd" /></svg></>;
}
IconListDefault.propTypes = ({
  srText: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  className: PropTypes.string
} as PropTypes.ValidationMap<Props>);
export default IconListDefault;